import { FunctionComponent, useEffect } from 'react';
import { useDispatch } from '@cbridge-utils/react-redux';
import { ClientLpAction } from '@cbridge-packages/lp-client';

export const ClientLpListSubscriber: FunctionComponent = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(ClientLpAction.loadList.started());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(ClientLpAction.destroy());
    };
  }, [dispatch]);

  return null;
};
